/* TT Mockup Modal Phase 1 (B1)
   Clean baseline rebuild + hardened close (pointerdown capture) + request link builder
   + broken-image hardening (no broken icon)
   + Step 12 FIX: right-chest mock name is FRONT-ONLY (hides on Back/Sleeve)
*/
(() => {
  'use strict';

  // ---------- mock name pools (mockup only) ----------
  const TT_MOCK_NAMES = {
    male: ['Walter', 'Jesse', 'Hank', 'Saul', 'Mike', 'Gus', 'Todd'],
    female: ['Skyler', 'Marie', 'Lydia', 'Jane', 'Andrea', 'Holly']
  };

  const TT_pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

  const TT_detectGender = (ov) => {
    // Priority 1: explicit overlay dataset (future-proof)
    const g = (ov.getAttribute('data-tt-mock-gender') || '').toLowerCase().trim();
    if (g === 'male' || g === 'female') return g;

    // Priority 2: page/product hints (simple + safe fallback)
    const body = document.body;
    const txt = ((body && body.className) ? body.className : '') + ' ' + (document.title || '');
    const t = txt.toLowerCase();

    if (t.includes('women') || t.includes('womens') || t.includes("women's") || t.includes('ladies')) return 'female';
    return 'male';
  };

  const TT_applyMockName = (ov) => {
    const nameEl = ov.querySelector('[data-tt-name]');
    if (!nameEl) return;

    const gender = TT_detectGender(ov);
    const pool = TT_MOCK_NAMES[gender] || TT_MOCK_NAMES.male;

    nameEl.textContent = TT_pick(pool);
    nameEl.hidden = false;
    nameEl.setAttribute('aria-hidden', 'false');
  };

  // Step 12: FRONT-only name visibility helper
  const TT_toggleNameForView = (ov, view) => {
  if (!ov) return;
  const nameEl = ov.querySelector('[data-tt-name]');
  if (!nameEl) return;

  const show = (view === 'front');

  if (show) {
    TT_applyMockName(ov);
    nameEl.hidden = false;
    nameEl.setAttribute('aria-hidden', 'false');
    nameEl.style.display = ''; // allow CSS default
    nameEl.style.visibility = '';
    nameEl.style.opacity = '';
    nameEl.style.pointerEvents = '';
  } else {
    nameEl.hidden = true;
    nameEl.setAttribute('aria-hidden', 'true');
    // HARD KILL (beats almost any CSS weirdness)
    nameEl.style.display = 'none';
    nameEl.style.visibility = 'hidden';
    nameEl.style.opacity = '0';
    nameEl.style.pointerEvents = 'none';
  }
};

  // ---------- helpers ----------
  const qs = (sel, root = document) => root.querySelector(sel);

  const getJson = (el, attr) => {
    if (!el) return null;
    const raw = el.getAttribute(attr);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  };

  const getDatasetVal = (el, key) => {
    if (!el) return '';
    const v = el.dataset ? el.dataset[key] : '';
    return (v || '').toString().trim();
  };

  const isUrl = (v) => typeof v === 'string' && v.trim().length > 0;

  const setHidden = (el, hide) => {
    if (!el) return;
    if (hide) {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    } else {
      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', 'false');
    }
  };

  const normalize = (v) => {
    const s = (v || '').toString().trim();
    if (!s) return '';
    const bad = ['null', 'undefined', 'false', '0', '#'];
    return bad.includes(s.toLowerCase()) ? '' : s;
  };

  // ---------- selectors ----------
  const OVERLAY_ID = 'ttMockupOverlayB1';
  const BODY_OPEN_CLASS = 'tt-mockup-open';

  // ---------- state ----------
  let overlay = null;

  let img = null;
  let emptyMsg = null;

  let btnFront = null;
  let btnBack = null;
  let btnSleeve = null;

  let requestLink = null;

  let sources = { front: '', back: '', sleeve: '' };
  let labels = { front: 'Front', back: 'Back', sleeve: 'Sleeve' };

  // ---------- core ----------
  const readSourcesFromOverlay = (ov) => {
    sources = {
      front: normalize(getDatasetVal(ov, 'mockFront')),
      back: normalize(getDatasetVal(ov, 'mockBack')),
      sleeve: normalize(getDatasetVal(ov, 'mockSleeve'))
    };
  };

  const syncViewButtons = () => {
    if (btnFront) setHidden(btnFront, !isUrl(sources.front));
    if (btnBack) setHidden(btnBack, !isUrl(sources.back));
    if (btnSleeve) setHidden(btnSleeve, !isUrl(sources.sleeve));
  };

  const setActivePill = (key) => {
    const all = [btnFront, btnBack, btnSleeve].filter(Boolean);
    all.forEach((b) => b.classList.remove('is-active'));

    const map = { front: btnFront, back: btnBack, sleeve: btnSleeve };
    const active = map[key];
    if (active) active.classList.add('is-active');
  };

  const showRequestState = () => {
    if (img) {
      // Remove src so browser cannot show a broken image icon
      img.removeAttribute('src');
      img.alt = 'Mockup unavailable';
      img.style.display = 'none';
      img.setAttribute('hidden', '');
    }

    if (btnFront) setHidden(btnFront, true);
    if (btnBack) setHidden(btnBack, true);
    if (btnSleeve) setHidden(btnSleeve, true);

    if (emptyMsg) setHidden(emptyMsg, false);
    if (requestLink) setHidden(requestLink, false);

    // If we’re in request state, the name should not show
    const ov = qs(`#${OVERLAY_ID}`);
    if (ov) TT_toggleNameForView(ov, '');
  };

  // Broken image hardening: bind once, then if the image fails, fall back to request state
  const bindImgErrorFallback = (imgEl) => {
    if (!imgEl || imgEl.dataset.ttErrBound === '1') return;
    imgEl.dataset.ttErrBound = '1';

    imgEl.addEventListener(
      'error',
      () => {
        showRequestState();
      },
      true
    );
  };

  const setView = (key) => {
    if (!isUrl(sources[key])) return;

    if (img) {
      // MUST bind before setting src
      bindImgErrorFallback(img);

      img.style.display = '';
      img.removeAttribute('hidden');
      img.alt = labels[key] || 'Mockup';
      img.src = sources[key];
    }

    if (emptyMsg) setHidden(emptyMsg, true);
    if (requestLink) setHidden(requestLink, true);

    setActivePill(key);

    // ✅ Step 12: Front-only right-chest name visibility
    const ov = overlay || qs(`#${OVERLAY_ID}`);
    if (ov) TT_toggleNameForView(ov, key);
  };

  const computeDefaultView = () => {
    if (isUrl(sources.front)) return 'front';
    if (isUrl(sources.back)) return 'back';
    if (isUrl(sources.sleeve)) return 'sleeve';
    return '';
  };

  const close = () => {
    const ov = qs(`#${OVERLAY_ID}`);
    if (!ov) return;

    setHidden(ov, true);
    document.body.classList.remove(BODY_OPEN_CLASS);

    ov.style.setProperty('display', 'none', 'important');
    ov.style.setProperty('visibility', 'hidden', 'important');
    ov.style.setProperty('opacity', '0', 'important');
    ov.style.setProperty('pointer-events', 'none', 'important');
  };

  const bindHardClose = (ov) => {
    const x =
      ov.querySelector('[data-tt-close="mockup-b1"]') ||
      ov.querySelector('.tt-mock-close');

    const bd =
      ov.querySelector('[data-tt-backdrop="mockup-b1"]') ||
      ov.querySelector('.tt-mock-backdrop');

    const hardClose = (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      close();
    };

    if (x && x.dataset.ttBoundClose !== '1') {
      x.dataset.ttBoundClose = '1';
      x.addEventListener('pointerdown', hardClose, true);
      x.addEventListener('click', hardClose, true); // harmless fallback
    }

    if (bd && bd.dataset.ttBoundBackdrop !== '1') {
      bd.dataset.ttBoundBackdrop = '1';
      bd.addEventListener('pointerdown', hardClose, true);
      bd.addEventListener('click', hardClose, true);
    }

    if (ov.dataset.ttBoundOverlay !== '1') {
      ov.dataset.ttBoundOverlay = '1';

      const overlayClose = (e) => {
        if (e.target !== ov) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        close();
      };

      ov.addEventListener('pointerdown', overlayClose, true);
      ov.addEventListener('click', overlayClose, true);
    }
  };

  const buildRequestUrl = (ov) => {
    const page = new URL(window.location.href);
    const client = (page.searchParams.get('client') || '').trim();
    const sku = normalize(getDatasetVal(ov, 'mockSku'));

    const req = new URL('/pages/mockup-request', window.location.origin);
    if (client) req.searchParams.set('client', client);
    if (sku) req.searchParams.set('sku', sku);
    req.searchParams.set('url', page.href);

    return req.pathname + '?' + req.searchParams.toString();
  };

  const open = () => {
    overlay = qs(`#${OVERLAY_ID}`);
    if (!overlay) return;

    img = qs('[data-tt-mock-img]', overlay);
    emptyMsg = qs('.tt-mock-empty', overlay);

    btnFront = qs('[data-tt-mock-view="front"]', overlay);
    btnBack = qs('[data-tt-mock-view="back"]', overlay);
    btnSleeve = qs('[data-tt-mock-view="sleeve"]', overlay);

    requestLink =
      qs('[data-tt-mock-request-link]', overlay) ||
      qs('[data-tt-mock-request]', overlay);

    const lbl = getJson(overlay, 'data-tt-mock-labels');
    if (lbl && typeof lbl === 'object') labels = { ...labels, ...lbl };

    // read sources
    readSourcesFromOverlay(overlay);

    // show overlay (undo forced hide)
    overlay.style.removeProperty('display');
    overlay.style.removeProperty('visibility');
    overlay.style.removeProperty('opacity');
    overlay.style.removeProperty('pointer-events');

    setHidden(overlay, false);
    document.body.classList.add(BODY_OPEN_CLASS);
    TT_toggleNameForView(overlay, 'front');

    // close wiring
    bindHardClose(overlay);

    // build request link (client + SKU tag + product url)
    if (requestLink) {
      requestLink.href = buildRequestUrl(overlay);
    }

    // pills
    syncViewButtons();

    // view / empty
    const def = computeDefaultView();
    if (!def) {
      showRequestState();
      return;
    }

    // ✅ Step 12: enforce front-only name visibility on initial view
    setView(def);
  };

  // expose
  window.TToppenMockupB1 = open;
  window.TTcloseMockupB1 = close;

  // ---------- global bindings ----------
  const bind = () => {
    // open buttons
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tt-mockup-open="b1"]');
      if (!btn) return;
      e.preventDefault();
      open();
    });

    // view pills (use pointerdown capture to avoid click suppression issues)
    document.addEventListener(
      'pointerdown',
      (e) => {
        const pill = e.target.closest('[data-tt-mock-view]');
        if (!pill) return;

        const ov = pill.closest(`#${OVERLAY_ID}`);
        if (!ov) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        overlay = ov; // keep state consistent

        readSourcesFromOverlay(ov);
        syncViewButtons();

        const key = pill.getAttribute('data-tt-mock-view');
        if (key && isUrl(sources[key])) setView(key);
      },
      true
    );

    // ESC close
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const ov = qs(`#${OVERLAY_ID}`);
      if (!ov) return;
      const isHidden = ov.hasAttribute('hidden') || ov.getAttribute('aria-hidden') === 'true';
      if (!isHidden) close();
    });

    // pageshow close (bfcache)
    window.addEventListener('pageshow', () => {
      const ov = qs(`#${OVERLAY_ID}`);
      if (!ov) return;
      setHidden(ov, true);
      document.body.classList.remove(BODY_OPEN_CLASS);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
